<header class="bg-app gold-rule sticky top-0 z-50 flex h-15 items-center justify-between gap-2 px-3">
  <a
    routerLink="/"
    class="shrink-0">
    <img
      priority
      ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/logo.png"
      width="105"
      height="38"
      alt="Pernod Selection · Inicio" />
  </a>

  <div class="flex items-center gap-3">
    @if(user(); as user) {
    <a
      routerLink="/profile"
      aria-label="Mi perfil"
      data-test="header-profile"
      class="focus-visible:outline-gold-peach shrink-0 rounded-full transition-transform duration-100 ease-out focus-visible:outline-2 focus-visible:outline-offset-2 active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100">
      <avatar
        [src]="user.avatar"
        priority />
    </a>
    } @if (showsBalance()) {
    <p
      class="flex items-center gap-1"
      data-test="header-balance">
      <img
        priority
        ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/coin.png"
        width="24"
        height="27"
        alt="" />
      <span class="flex flex-col leading-tight">
        <span class="text-gold-cream text-caption font-medium">Monedas</span>
        <span class="text-gold-peach text-label font-bold">{{ user()?.points ?? 0 | number }}</span>
      </span>
    </p>
    }

    <button
      type="button"
      class="relative shrink-0 rounded-full transition-transform duration-100 ease-out active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100"
      [attr.aria-label]="notifications.unread() ? 'Notificaciones, ' + notifications.unread() + ' sin leer' : 'Notificaciones'"
      (click)="openNotifications()">
      <img
        priority
        ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/notificaciones.png"
        width="20"
        height="20"
        alt="" />

      @if (notifications.unread(); as unread) {
      <span
        aria-hidden="true"
        class="bg-action-red text-caption border-app absolute -top-1.5 -right-2 grid size-[18px] place-items-center rounded-full border-2 font-bold text-white">
        {{ unread > 9 ? '9+' : unread }}
      </span>
      }
    </button>

    <button
      type="button"
      aria-label="Cerrar sesión"
      class="icon-button-navy grid size-6 shrink-0 place-items-center rounded-full text-white transition-transform duration-100 ease-out active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100"
      (click)="logout()">
      <icon
        name="log-out"
        [size]="14" />
    </button>
  </div>
</header>
